import { MenuProps, components } from "react-select";
import { TClueSelectDefaultOption } from "../../ClueSelect.types";
import "./Menu.styles.scss";

export const Menu = <
  Option extends TClueSelectDefaultOption = TClueSelectDefaultOption
>(
  props: MenuProps<Option, false>
): JSX.Element => {
  return (
    <components.Menu {...props} className="nb-interactive-clue-select-menu">
      {props.children}
    </components.Menu>
  );
};
